<template>
  <ConteudoPageForm
    apiBasePath="/admin/site-paginas"
    entityName="Página"
    breadcrumb="Marketing / Páginas"
    listRouteName="paginas"
    iaEndpoint="/admin/site-paginas/gerar-conteudo-ia"
    iaPlaceholder="Ex: Política de trocas e devoluções"
  />
</template>

<script>
import ConteudoPageForm from '../../components/ConteudoPageForm';

export default {
  name: 'PaginaForm',
  components: { ConteudoPageForm },
};
</script>
